import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

export default function ColombieCadet({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header="Colombie Cadet" visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="colombieCadetPanel">
            <Trans i18nKey="colombieCadetDetails" />

            <h2 className="text-center titles text-800">{t("technologies")}</h2>

            <p className="text-center">Java, php, Rest Api</p>
        </Dialog>
    )
}